import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

// 路由重复 报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export default new Router({
  // mode: "history",
  routes: [
    { path: "/", redirect: "/index" },
    {
      path: "/shouye",
      name: "首页",
      component: () => import("@/views/index"),
      children: [
        {
          path: "/index",
          name: "首页",
          component: () => import("@/views/homeIndex/home")
        },
        {
          path: "/index/strategy",
          name: "产品攻略",
          component: () => import("@/views/strategy/index")
        },
        {
          path: "/index/notice",
          name: "更新公告",
          component: () => import("@/views/notice/index")
        },
        {
          path: "/index/about",
          name: "关于我们",
          component: () => import("@/views/about/about")
        }
      ]
    },
    {
      path: "/software",
      name: "拼版软件",
      component: () => import("@/views/pinban/software")
    },
    {
      path: "/signup",
      name: "注册",
      component: () => import("@/views/signup/webregister")
    },
    {
      path: "/signin",
      name: "登录",
      component: () => import("@/views/signup/signin")
    },
    {
      path: "/userpage",
      name: "个人中心",
      component: () => import("@/views/signup/userpage")
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js